const Kpi = ({ label, value, sub, accent, testId, delay }) => (
  <div className="panel fade-up p-5" style={{ animationDelay: `${delay}ms` }}>
    <div className="label">{label}</div>
    <div data-testid={testId} className={`mt-3 font-mono text-3xl font-extrabold sm:text-4xl ${accent}`}>{value}</div>
    {sub && <div className="mt-1 font-mono text-xs text-[color:var(--muted)]">{sub}</div>}
  </div>
);

export const KpiCards = ({ stats }) => {
  const pct = stats.total ? ((stats.done / stats.total) * 100).toFixed(1) : "0.0";
  return (
    <div className="grid grid-cols-2 gap-4 lg:grid-cols-5">
      <Kpi delay={0} label="Total Scope" value={stats.total} sub="assigned items" accent="text-[color:var(--fg)]" testId="kpi-total-scope" />
      <Kpi delay={60} label="Completed" value={`${stats.done} / ${stats.total}`} sub={`${pct}%`} accent="text-emerald-400" testId="kpi-done-count" />
      <Kpi delay={120} label="In Progress" value={stats.inProgress} sub="items" accent="text-sky-400" testId="kpi-in-progress-count" />
      <Kpi delay={180} label="Not Started" value={stats.notStarted} sub="items" accent="text-slate-400" testId="kpi-not-started-count" />
      <Kpi delay={240} label="Weighted Progress" value={`${stats.overallPct.toFixed(1)}%`} sub={`${stats.donePoints} / ${stats.totalPoints} pts`} accent="text-amber-400" testId="kpi-overall-productivity" />
    </div>
  );
};
